import React from 'react';

const PasswordInput = ({ value, onChange }) => {
  return (
    <input
      type="password"
      value={value}
      onChange={onChange}
      className="w-full p-2 border border-gray-300 rounded"
      placeholder="Password"
      required
    />
  );
};

export default PasswordInput;